// 礼品卡 | 现金券
const config = {
  'Ecard.problemTip': {
    operation: ['touch', 'visible'],
    title: '礼品卡常见问题说明',
    c: {
      type: 'variable',
      func: function ({ isCash }) {
        return isCash ? 'problem_cashcoupons' : 'problem_giftcard';
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function ({ url = '' }) {
        return `u=${url}`;
      },
    },
  },
  'Ecard.newCardBtn': {
    operation: ['touch', 'visible'],
    title: '绑定新卡1',
    c: {
      type: 'variable',
      func: function ({ isCash }) {
        return isCash ? 'new_cashcoupons1' : 'new_card1';
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Ecard.cartItem.touch': {
    operation: ['touch'],
    title: '卡片勾选',
    c: {
      type: 'variable',
      func: function ({ isCash }) {
        return isCash ? 'check_cashcoupons' : 'check_giftcard';
      },
    },
    d: {
      type: 'variable',
      func: function (traceData) {
        const { index } = traceData;
        return `${index + 1}`;
      },
    },
    iid: {
      type: 'variable',
      func: function (traceData) {
        const { cardId, selected } = traceData;
        return `card_id=${cardId}&status=${selected ? 0 : 1}`;
      },
    },
  },
  'Ecard.list.itemVisible': {
    operation: ['visible'],
    title: '礼品卡item曝光',
    getParse: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const { cardId } = item.item || {};
        const index = item.index;
        const { scmv2 = '', pageName, traceObj } = args;
        const { isCash = false } = traceObj || {};
        return {
          type: 'rec_list',
          item: item.item,
          isViewable: item.isViewable,
          key: item.key,
          index: index,
          page: pageName,
          b: pageName,
          c: isCash ? 'cashcoupons' : 'giftcard',
          d: index + 1,
          iid: `card_id=${cardId}`,
          scmv2: scmv2,
        };
      },
    },
  },
  'Ecard.confirm': {
    operation: ['touch', 'visible'],
    title: '底部按钮确认勾选|绑定新卡',
    c: {
      type: 'variable',
      func: function (traceData) {
        const { mode, isCash } = traceData;
        if (mode === 'ensure') {
          return isCash ? 'order_cashcoupons' : 'order_giftcard';
        } else {
          return isCash ? 'new_cashcoupons2' : 'new_card2';
        }
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function (traceData) {
        const { mode, isCash, ecardList } = traceData;
        const cardIds = ecardList.filter((item) => item.selected).map((item) => item.cardId);
        return mode === 'ensure' ? `card_id=${cardIds.join('_')}` : '';
      },
    },
  },
  'Ecard.bindcard.modal': {
    operation: ['visible'],
    title: '绑卡弹层曝光',
    c: {
      type: 'variable',
      func: function ({ isCash }) {
        return isCash ? 'bindcashcoupons_pop' : 'bindgiftcard_pop';
      },
    },
    d: {
      type: 'variable',
      func: function (traceData) {
        return '1';
      },
    },
  },
  'Ecard.bindcard.closeBtn': {
    operation: ['touch'],
    title: '绑卡弹层关闭按钮',
    c: {
      type: 'variable',
      func: function ({ isCash }) {
        return isCash ? 'close_bindcashcoupons' : 'close_bindgiftcard';
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Ecard.bindcard.password': {
    operation: ['touch'],
    title: '绑卡密码输入框',
    c: {
      type: 'variable',
      func: function ({ isCash }) {
        return isCash ? 'password_cashcoupons' : 'password_giftcard';
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Ecard.bindcard.code': {
    operation: ['touch'],
    title: '绑卡验证码输入框',
    c: {
      type: 'variable',
      func: function ({ isCash }) {
        return isCash ? 'code_cashcoupons' : 'code_giftcard';
      },
    },
    d: {
      type: 'variable',
      func: function (traceData) {
        return '1';
      },
    },
  },
  'Ecard.bindcard.refreshcode': {
    operation: ['touch'],
    title: '获取验证码',
    c: {
      type: 'variable',
      func: function ({ isCash }) {
        return isCash ? 'refreshcode_cashcoupons' : 'refreshcode_giftcard';
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Ecard.bindcard.confirm': {
    operation: ['touch', 'visible'],
    title: '绑卡确认',
    c: {
      type: 'variable',
      func: function ({ isCash }) {
        return isCash ? 'order_bindcashcoupons' : 'order_bindgiftcard';
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
};

export default config;
